module.exports = __webpack_public_path__ + "media/images/makehub_white-93206236d597218bc75399596e30f9d3.png";